import { Trans, useTranslation } from "react-i18next";
import { Etracker } from "spot-component-library/lib/components/etracker/Etracker";
import { readLanguageFromCookie } from "../../components/GeneralUtils";
import React, { useEffect } from "react";
import AppContainer from "spot-component-library/lib/components/layout/app-container/AppContainer";
import tenantService from "../../services/TenantService";
import "./Eaa-privacy-page.scss";

const EaaPrivacyPage = () => {
    const { t } = useTranslation();
    const [tenant, setTenant] = React.useState<string>("");
    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        const tenant = await tenantService.getTenant();
        setTenant(tenant);
    };

    return (
        <>
            <AppContainer header={{ menuLoginEnabled: false }}>
                <Etracker pageName={"EAA_Privacy_Page"} popto={"1500"} tenant={tenant.toString()} language={readLanguageFromCookie()} />
                <div className={"eaa-privacy-page"}>
                    <h1>
                        <Trans i18nKey="EAA_PRIVACY_PAGE.HEADLINE1" />
                    </h1>
                    <p>
                        <Trans i18nKey="EAA_PRIVACY_PAGE.HEADLINE_TEXT1" />
                    </p>
                    <h2>
                        <Trans i18nKey="EAA_PRIVACY_PAGE.HEADLINE2" />
                    </h2>
                    <p>
                        <Trans i18nKey="EAA_PRIVACY_PAGE.HEADLINE_TEXT2" />
                    </p>
                    <h2>
                        <Trans i18nKey="EAA_PRIVACY_PAGE.HEADLINE3" />
                    </h2>
                    <p>
                        <Trans i18nKey="EAA_PRIVACY_PAGE.HEADLINE_TEXT3" />
                    </p>
                </div>
            </AppContainer>
        </>
    );
};

export default EaaPrivacyPage;
